import React from "react";
import { GatsbyImage, GatsbyImageProps } from "gatsby-plugin-image";

export default function Image(props: GatsbyImageProps) {
  return <GatsbyImage {...props} />;
}
